import React, { Component } from 'react';
import ChartLoader from '../../../components/Loaders/ChartLoader';

import { chartBlue, chartRed, chartYellow } from '../../../shared/config';
import Auth from '../../../shared/Auth';
import CustomLineChart from '../../Custom/CustomLineChart';
import axios from '../../../utils/axiosClient';

const initChartObj = {
  title: 'Energy Profile',
  unit: `Energy ( - )`,
  series: [
    {
      name: 'Energy-R',
      color: chartRed,
      data: [],
    },
    {
      name: 'Energy-Y',
      color: chartYellow,
      data: [],
    },
    {
      name: 'Energy-B',
      color: chartBlue,
      data: [],
    },
  ],
};

class EnergyProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialize: true,
      options: {},
      chartObj: null,
    };
    this.chart = null;
  }

  componentDidMount() {
    this.fetchData(this.props.assetId, 1);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.assetId !== nextProps.assetId) {
      this.fetchData(nextProps.assetId, 1);
    }
  }

  async fetchData(assetId, noOfMonths) {
    //noOfMonths = 1 or 0 1 - 1month,0 - 6month
    this.setState({ initialize: true });

    const self = this;
    const checkToken = await Auth();
    if (checkToken) {
      const url = `report/energyprofilebyassetId/${assetId}/${noOfMonths}`;
      axios
        .get(url) //1 for 1 month data load
        .then((response) => {
          if (response.data.statusCode === 200) {
            let current_R = [];
            let current_Y = [];
            let current_B = [];
            let unit = '';
            const { result } = response.data;
            if (result.length > 0) {
              unit = result[0][0].EnergyUnit;
              result[1].forEach(async (element) => {
                const tmstmp = Date.parse(
                  element.RptDateTime.replace('_', ' ')
                );
                current_R.push([tmstmp, parseFloat(element.AEnergy_R)]);
                current_Y.push([tmstmp, parseFloat(element.AEnergy_Y)]);
                current_B.push([tmstmp, parseFloat(element.AEnergy_B)]);
              });
            }

            const chartObj = {
              title: 'Energy Profile',
              unit: `Energy (${unit})`,
              selected: noOfMonths === 1 ? 0 : 3,
              series: [
                {
                  name: 'Energy-R',
                  color: chartRed,
                  data: current_R,
                },
                {
                  name: 'Energy-Y',
                  color: chartYellow,
                  data: current_Y,
                },
                {
                  name: 'Energy-B',
                  color: chartBlue,
                  data: current_B,
                },
              ],
              evnt: () => self.fetchData(assetId, 6),
            };

            this.setState({
              chartObj,
              initialize: false,
            });
          } else {
            this.setState({ chartObj: initChartObj, initialize: false });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ chartObj: initChartObj, initialize: false });
        });
    }
  }

  render() {
    return (
      <div>
        {this.state.initialize ? (
          <ChartLoader height="150" width="600" />
        ) : (
          <CustomLineChart options={this.state.chartObj} />
        )}
      </div>
    );
  }
}
export default EnergyProfile;
